import React, { Component } from 'react';
import {Link} from 'react-router-dom';

export default class Navbar extends Component {

    constructor(props){
        super(props);
    }

    render() {
        return (
            <div className="container nav-bar">
                <ul className="nav justify-content-center">
                <li className="nav-item">
                        <Link
                            to={'/'}
                            className={`nav-link ${this.props.location.pathname === '/' ? 'active' : ''}`}
                        >
                            Albums
                        </Link>
                    </li>
                    {user.admin ?
                        <li className="nav-item">
                            <Link
                                to={'/album/create'}
                                className={`nav-link ${this.props.location.pathname === '/album/create' ? 'active' : ''}`}
                            >
                                Create an album
                            </Link>
                        </li>
                    : null}
                    {user.admin ?
                    <li className="nav-item">
                        <Link
                            to={'/upload'}
                            className={`nav-link ${this.props.location.pathname === '/upload' ? 'active' : ''}`}
                        >
                            Uploader
                        </Link>
                    </li>
                    : null}
                    {user.admin ?
                    <li className="nav-item">
                        <Link
                            to={'/manage'}
                            className={`nav-link ${this.props.location.pathname === '/manage' ? 'active' : ''}`}
                        >
                            Manage
                        </Link>
                    </li>
                    : null}
                    <li className="nav-item">
                        <a className="nav-link" href="/logout">Logout</a>
                    </li>
                </ul>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./resources/assets/js/components/Navbar.js